var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TotemSelect',{ref:"selectInstructor",staticClass:"filter-select",attrs:{"options":_vm.instructorsOptions,"placeholder":_vm.$t('CourseListFilter.instructor'),"value":_vm.selectedInstructor},on:{"input":_vm.selectInstructor}})}
var staticRenderFns = []

export { render, staticRenderFns }